import React, { PropsWithChildren, ReactElement, useContext } from "react";
import { Route } from "react-router-dom";
import { AuthReferences } from "@iloq/shared-vue";
import { VueRouteSerializer } from "@iloq/shared-vue";

import VueContext from "./vueContext";

// NOTE: This needs to be refactored once moving to react-router v6,
// see https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f#background
export function PrivateRoute({ children, ...rest }: PropsWithChildren<any>): ReactElement {
  const { $router: vueRouter } = useContext(VueContext);

  return (
    <Route
      {...rest}
      render={({ match, location }) => {
        const hasRefreshToken = AuthReferences.hasRefreshToken();

        if (!hasRefreshToken) {
          // Use same route serializer as in Vue and trigger re-login with Vue's router
          VueRouteSerializer.saveReactRoute(location);
          vueRouter.push("/re-login");

          return null;
        }

        // Support both functions and React components as children
        return typeof children === "function" ? children({ match, location }) : children;
      }}
    />
  );
}
